module.exports = __webpack_public_path__ + "img/BL.39375967.svg";